import { SharingDialog } from './';
import { connect } from 'react-redux';
import { 
  namespace as userManagmentNamespace, 
  loadOrgUsers, 
  loadTeams 
} from '../../state/modules/app/userManagement/actions';
import {
  namespace as dialogNameSpace,
  Status as dialogStatus,
  closeDialog
} from '../../state/modules/app/dialogStatus/actions';
import { DIALOG_SHARE_CAMPAIGN } from '../../helpers/constant';
import { get } from 'lodash';
import { loadAdvertisers, namespace as advertiserNameSpace } from '../../state/modules/app/advertiser';
import { namespace as campaignNameSpace, loadCampaigns, updateCampaignPermissions } from '../../state/modules/app/campaign/actions';

const ShareCampaignDialog = connect(
  state => {
    const id = get(state, [dialogNameSpace, 'dialogs', DIALOG_SHARE_CAMPAIGN, 'value']);
    const openStatus = get(state, [dialogNameSpace, 'dialogs', DIALOG_SHARE_CAMPAIGN, 'status']);
    const campaign = get(state, [campaignNameSpace, 'byId', id]);
    const campaignLoadStatus = get(state, [campaignNameSpace, 'status']);
    const currentUserId = get(state, 'user.user.userId');
    const entityName = get(campaign, 'campaign_name', 'this campaign');
    const editors = get(campaign, 'editors', []);
    const viewers = get(campaign, 'viewers', []);
    const advertiserId = get(campaign, 'advertiser_id');
    const advertiser = get(state, [advertiserNameSpace, 'byId', advertiserId], {});
    const ownerId = get(advertiser, 'owner', '');
    const advertiserEditors = get(advertiser, 'editors', []);
    const advertiserViewers = get(advertiser, 'viewers', []);
    const advertiserLoadStatus = get(state, [advertiserNameSpace, 'status']);
    const users = get(state, [userManagmentNamespace, 'users', 'data'], []);
    const teams = get(state, [userManagmentNamespace, 'teams', 'data'], []);
    const userLoadStatus = get(state, [userManagmentNamespace, 'users', 'status']);
    const teamLoadStatus = get(state, [userManagmentNamespace, 'teams', 'status']);
    const usersHashMap = users.reduce((accum, user) => {
      if (user.id) {
        accum[user.id] = {...user};
      }
      return accum;
    }, {});

    const memberManagerHashMap = teams && teams.reduce((accum, currentTeam) => {
      const { memberIds, managerIds} = currentTeam;
      memberIds && memberIds.forEach( id => {
        if(!accum[id]) {
          accum[id] = [];
        }
        accum[id] = [...accum[id], ...managerIds];
      });
      return accum;
    }, {});

    const currentUser = usersHashMap[currentUserId];
    if(currentUser) {
      currentUser.isCurrentUser = true;
    }
    
    const inheritIds = [];
    advertiserEditors && inheritIds.push(...advertiserEditors);
    advertiserViewers && inheritIds.push(...advertiserViewers);

    return {
      id,
      dialogName: DIALOG_SHARE_CAMPAIGN,
      label: 'Share Campaign',
      open: openStatus === dialogStatus.STATUS_OPEN,
      entityName,
      users,
      teams,
      ownerId,
      editors,
      viewers,
      inheritIds,
      currentUserId,
      usersHashMap,
      memberManagerHashMap,
      userLoadStatus,
      teamLoadStatus,
      campaignLoadStatus,
      advertiserLoadStatus,
      autoCompleteSubtitle: 'Grants access to this campaign'
    }
  },
  {
    loadOrgUsers,
    loadTeams,
    loadCampaigns,
    loadAdvertisers,
    onChange: updateCampaignPermissions,
    onClose: closeDialog
  })(SharingDialog);

  export default ShareCampaignDialog;
